export default __webpack_public_path__ + "static/media/case_placeholder.71a1988e.jpg";